// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"ResourceTagList_tagContainer__2jABR","tag":"ResourceTagList_tag__2yvaU","closeButton":"ResourceTagList_closeButton__2i4Aa"};